import svgUrl from "ni:svgr;CN4u6jtmMwT4lqKejjcC6iwJkA29lvYe3fKPefiwHIA";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const UiSortByAscendingSIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M1.5 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2ZM1 6.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5ZM1.5 9a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7Zm0 3a.5.5 0 0 0 0 1h12a.5.5 0 0 0 0-1h-12Z" clipRule="evenodd" /></svg>;
const Memo = memo(UiSortByAscendingSIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "ui-node-icon(UiSortByAscendingSIcon)";
}